

import imgStock from '../assets/stock.png'
import imgTax from '../assets/tax.png'
import imgDiscount from '../assets/discount.png'
import imgReport from '../assets/report.png'
import imgAccounting from '../assets/accounting.png'
import imgMultiUser from '../assets/multiuser.png'
import imgMultiLocation from '../assets/multilocation.png'
import imgCashier from '../assets/cashier.png'

function App() {
    return <div >
        <div className='container mt-5 mb-5'>
            <h1 className='text-center mb-5'>Fitur Aplikasi KASIRKU BAGUS</h1>
            <div className='row' style={{ rowGap: '20px' }}>

                <div className='col-md-3 text-center'>
                    <div className='d-flex justify-content-center  align-items-center p-4'>
                        <img src={imgStock} style={{ width: '100px', height: '100px' }} />
                    </div>
                    <h5>Manajemen Stok Barang</h5>
                    <p>Menampilkan informasi mengenai stock barang pada perusahaan anda.</p>
                </div>

                <div className='col-md-3 text-center'>
                    <div className='d-flex justify-content-center  align-items-center p-4'>
                        <img src={imgAccounting} style={{ width: '100px', height: '100px' }} />
                    </div>
                    <h5>Pembukuan Akutansi</h5>
                    <p>Melakukan transaksi dengan konsep dasar pembukuan akutansi.</p>
                </div>

                <div className='col-md-3 text-center'>
                    <div className='d-flex justify-content-center  align-items-center p-4'>
                        <img src={imgCashier} style={{ width: '100px', height: '100px' }} />
                    </div>
                    <h5>Point Of Sale (POS)</h5>
                    <p>Support mode tampilan kasir yang memudahkan penjualan anda </p>
                </div>


                <div className='col-md-3 text-center'>
                    <div className='d-flex justify-content-center  align-items-center p-4'>
                        <img src={imgMultiLocation} style={{ width: '100px', height: '100px' }} />
                    </div>
                    <h5>Multi Lokasi</h5>
                    <p>Bertransaksi dengan sistem multi cabang</p>
                </div>

                <div className='col-md-3 text-center'>
                    <div className='d-flex justify-content-center  align-items-center p-4'>
                        <img src={imgReport} style={{ width: '100px', height: '100px' }} />
                    </div>
                    <h5>Laporan dan Analisis Bisnis </h5>
                    <p>Informasi laporan penjualan, pendapatan, inventory, dan lain-lain</p>
                </div>

                <div className='col-md-3 text-center'>
                    <div className='d-flex justify-content-center  align-items-center p-4'>
                        <img src={imgTax} style={{ width: '100px', height: '100px' }} />
                    </div>
                    <h5>Sistem Pajak</h5>
                    <p>Tambahkan nominal pajak kedalam transaksi anda</p>
                </div>

                <div className='col-md-3 text-center'>
                    <div className='d-flex justify-content-center  align-items-center p-4'>
                        <img src={imgDiscount} style={{ width: '100px', height: '100px' }} />
                    </div>
                    <h5>Sistem Diskon</h5>
                    <p>Tambahkan potongan harga kedalam transaksi anda</p>
                </div>

                <div className='col-md-3 text-center'>
                    <div className='d-flex justify-content-center  align-items-center p-4'>
                        <img src={imgMultiUser} style={{ width: '100px', height: '100px' }} />
                    </div>
                    <h5>Multi User</h5>
                    <p>Support Multi Pengguna, dengan macam-macam hak akses</p>
                </div>

            </div>
        </div>
    </div>
}

export default App